import { useState, useMemo } from "react";
import { useGrowerAssignment, type EntitySortOption } from "../shared";
import type { BranchConfigurationProps } from "./BranchConfiguration.types";

export function useBranchConfigurationViewModel(props: BranchConfigurationProps) {
	const { jobs, branches, branchAssignments, onAssignGrowerToBranch } = props;

	const shared = useGrowerAssignment({
		jobs,
		entities: branches,
		assignments: branchAssignments,
		onAssign: onAssignGrowerToBranch,
	});

	// Branch sort state
	const [branchSortOption, setBranchSortOption] = useState<EntitySortOption>("default");

	const filteredSortedBranches = useMemo(() => {
		if (branchSortOption === "default") return branches;

		return [...branches].sort((a, b) => {
			switch (branchSortOption) {
				case "name-asc":
					return a.name.localeCompare(b.name);
				case "name-desc":
					return b.name.localeCompare(a.name);
				case "growers-desc": {
					const aCount = (shared.growersByEntity.get(a.id) || []).length;
					const bCount = (shared.growersByEntity.get(b.id) || []).length;
					return bCount - aCount;
				}
				case "growers-asc": {
					const aCount = (shared.growersByEntity.get(a.id) || []).length;
					const bCount = (shared.growersByEntity.get(b.id) || []).length;
					return aCount - bCount;
				}
				default:
					return 0;
			}
		});
	}, [branches, branchSortOption, shared.growersByEntity]);

	return {
		...shared,
		branchSortOption,
		setBranchSortOption,
		filteredSortedBranches,
		totalBranchCount: branches.length,
	};
}
